<template>
  <div>
    <el-form-item prop="name" :label="field.name + '：'" label-width="110px">
      <el-radio-group v-model="radio" @change="change">
        <span v-for="item in field['radio-list']" class="radio-item">
          <el-radio :label="item.value">{{ item.label }}</el-radio>
        </span>
      </el-radio-group>
    </el-form-item>
    <el-form-item label-width="110px" v-if="config[field.key] == 1">
      <el-color-picker v-model="config['background_color']"></el-color-picker>
    </el-form-item>
    <el-form-item label-width="110px" v-if="config[field.key] == 2">
      <image-uploader
        :uploadedImg="config['background_image']"
        @uploaded="handleUpload"
        tip="建议图片宽度：640px<br />请注意图片长图，图片长图不足有可能导致图片无法覆盖页面底部"
      ></image-uploader>
    </el-form-item>
  </div>
</template>

<style lang="scss" scoped>
.radio-item {
  padding-right: 20px;
}
</style>

<script>
import ImageUploader from "@/components/ImageUploader.vue";
export default {
  name: "tms-type-page-background",
  props: {
    field: {
      type: [Object, Array],
      required: true,
    },
    // config: {
    //   type: Object,
    //   default() {
    //     return {}
    //   }
    // },
    source: {
      type: String,
    },
  },
  computed: {
    // 基础组件的 数据初始化 判断是常规组件渲染 还是基础组件渲染
    config() {
      if (this.source === "tmsPageConfig") {
        return this.$store.state.tms.pageData;
      }
      if (this.source === "tmsModuleConfig") {
        return this.$store.state.tms.config;
      }
      return this.$store.state.tms.customConfig;
    },
  },
  data() {
    return {
      radio: 0,
    };
  },

  components: {
    ImageUploader,
  },

  mounted() {
    // 进入页面有颜色则将 背景raido为1 否则为0
    this.config.background_type = this.config.background_color ? "1" : "0";
    if (!this.config[this.field.key]) {
      this.config[this.field.key] = "0";
    } else {
      this.radio = this.config[this.field.key] * 1;
    }
  },

  methods: {
    change(val) {
      this.config[this.field.key] = val;
      if (val == 0) {
        this.$set(this.config, "background_color", "");
      }
    },
    handleUpload(src, index) {
      this.config["background_image"] = src;
    },
    headleChangeColor(color) {
      // this.config["background_color"] = color;
      this.$set(this.config, "background_color", color);
    },
  },
};
</script>
